import { clsx } from 'clsx'
import { type FC } from 'react'

import { ProductPageAttributesSelection } from '../ProductPageAttributesSelection'
import { ProductPageContactLensesInfoNotification } from '../ProductPageContactLensesInfoNotification/ProductPageContactLensesInfoNotification'
import { useProductPageContext } from '../productPageContext'

import { ProductAddToCartGroup } from './ProductAddToCartGroup'
import { ProductBuyBoxNowDetails } from './ProductBuyBoxNowDetails'
import {
  ProductPageMobileRadioStyleAttributesSelection,
  ProductPageSingleAttributesHeader,
  ProductPageSingleAttributesHeaderLabels,
} from './ProductPageSingleAttributes'
import { ProductVariantHeader } from './ProductVariantHeader'

export const ProductBuyBoxCom: FC = () => {
  const { attributeSelectionControls } = useProductPageContext()
  const { hasSingleRenderGroup } = attributeSelectionControls

  const showOnlyOnDesktopClassName = clsx(
    hasSingleRenderGroup && 'hidden tablet:block',
  )

  const showOnlyOnMobileClassName = clsx(
    hasSingleRenderGroup && 'tablet:hidden',
  )

  return (
    <div className="mb-5 w-full">
      {hasSingleRenderGroup ? (
        <div className={showOnlyOnMobileClassName}>
          <ProductPageSingleAttributesHeaderLabels />
        </div>
      ) : null}

      <div className="w-full rounded-m bg-light-primary-medium px-4 pb-2.5 pt-5">
        <div className={showOnlyOnDesktopClassName}>
          <ProductVariantHeader />
        </div>

        {/* on mobile case single we do not show "normal" attribute selection but "old school one" */}
        {hasSingleRenderGroup ? (
          <div className={showOnlyOnMobileClassName}>
            <ProductPageSingleAttributesHeader />
          </div>
        ) : null}
        <div className={showOnlyOnDesktopClassName}>
          <ProductPageAttributesSelection />
        </div>
        <ProductBuyBoxNowDetails />
        <ProductAddToCartGroup />
        <ProductPageContactLensesInfoNotification />
        {/* on mobile case single we do not show "normal" attribute selection but "old school one" */}
        {hasSingleRenderGroup ? (
          <ProductPageMobileRadioStyleAttributesSelection
            className={showOnlyOnMobileClassName}
          />
        ) : null}
      </div>
    </div>
  )
}
